import Text from '@common/models/Text';
import Cta from '@components/Cta';
import SectionHeading from '@components/SectionHeading';
import TextContent from '@layouts/common/TextContent';
import React from 'react';

export interface TextProps {
  text: Text;
}

const TextLayout: React.FC<TextProps> = ({ text }) => {
  const { ctaLink, ctaText, showCta, texts } = text;
  return (
    <div className="flex flex-col justify-center items-center">
      <SectionHeading className="mb-24 text-center" text={texts[0]?.heading} />
      <TextContent className="text-center mb-24" text={texts[0]?.paragraph} />
      {showCta && <Cta link={ctaLink} text={ctaText} />}
    </div>
  );
};

export default TextLayout;
